import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _toConsumableArray from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import { getStoneList } from '@/service/proRequisition';
export default function userList(params) {
  var loading = ref(false);
  var finished = ref(false);
  var list = ref([]);
  var getStoneListAsync = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _list$value, data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            loading.value = true;
            _context.next = 4;
            return getStoneList(params.value);
          case 4:
            data = _context.sent;
            (_list$value = list.value).push.apply(_list$value, _toConsumableArray(data.data));
            // 数据全部加载完成
            if (data.total === list.value.length) {
              finished.value = true;
            }
            // 加载状态结束
            loading.value = false;
            _context.next = 13;
            break;
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](0);
            params.value.page -= 1;
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 10]]);
    }));
    return function getStoneListAsync() {
      return _ref.apply(this, arguments);
    };
  }();
  var onLoad = function onLoad() {
    params.value.page += 1;
    getStoneListAsync();
  };
  return [list, loading, finished, getStoneListAsync, onLoad];
}